export enum ExistingLoan {
  NONE = '0',
  NO = '1',
  YES = '2',
}
